module.exports = __webpack_public_path__ + "static/level-2-logo.c37de559.png";